import React from "react";
import { sliceString } from "../../theme/helpers";
import Video from "../Icons/Video";
import Gallery from "../Icons/Gallery";
import Podcast from "../Icons/Podcast";
import { Appla, CardContent, ArticleDate, ArticleTitle, ArticleIntro, CardCover, TagsContainerTop } from "../CardArticle/CardArticle.styled";
import { CardCoverMultimedia, MultimediaTag, Multimedia, MultimediaBig } from "./CardMultimedia.styled";
export var displayMultimediaIcon = function displayMultimediaIcon(type) {
  switch (type) {
    case 'video':
      return React.createElement(Video, null);

    case 'gallery':
      return React.createElement(Gallery, null);

    case 'podcast':
      return React.createElement(Podcast, null);

    default:
      return;
  }
};

var CardMultimedia = function CardMultimedia(_a) {
  var type = _a.type,
      size = _a.size,
      date = _a.date,
      title = _a.title,
      description = _a.description,
      coverUrl = _a.coverUrl,
      url = _a.url;
  return React.createElement(React.Fragment, null, size === 'default' && React.createElement(Multimedia, {
    to: url
  }, React.createElement(CardCoverMultimedia, {
    coverUrl: coverUrl
  }, React.createElement(Appla, null), !!type && React.createElement(MultimediaTag, null, displayMultimediaIcon(type))), React.createElement(CardContent, null, React.createElement(ArticleTitle, null, sliceString(title, 95)), React.createElement(ArticleDate, null, date), React.createElement(ArticleIntro, null, sliceString(description, 138)))), size === 'big' && React.createElement(MultimediaBig, {
    to: url
  }, React.createElement(CardCover, {
    coverUrl: coverUrl
  }, React.createElement(Appla, null), React.createElement(TagsContainerTop, null, !!type && React.createElement(MultimediaTag, null, displayMultimediaIcon(type))), React.createElement(CardContent, null, React.createElement(ArticleTitle, null, sliceString(title, 118)), React.createElement(ArticleIntro, null, sliceString(description, 155))))));
};

export default CardMultimedia;